import type { Restaurant } from '../services/restaurantService';

/** Parse a numeric rating from API values that may be number or string. */
export function parseRatingValue(value: unknown): number | null {
  if (value == null) return null;
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = Number.parseFloat(value.trim());
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  }
  return null;
}

/** Best display rating for a restaurant listing card. */
export function getRestaurantDisplayRating(restaurant: Restaurant): number | null {
  const customerAvg = parseRatingValue(restaurant.customerReviews?.averageRating);
  if (customerAvg != null) return customerAvg;

  const peppar = parseRatingValue(restaurant.pepparRating);
  if (peppar != null) return peppar;

  const primary = parseRatingValue(restaurant.rating);
  if (primary != null) return primary;

  const links = restaurant.socialLinks;
  if (!links) return null;

  const candidates = [
    restaurant.pepparRating,
    links.googleReviewsRating,
    links.zomatoRating,
    links.swiggyRating,
  ]
    .map(parseRatingValue)
    .filter((r): r is number => r != null);

  if (candidates.length === 0) return null;
  return Math.max(...candidates);
}
